import * as React from 'react';
import { useSearchParams } from 'react-router-dom';

import { rootStore } from '../instance';

type SystemParamsStoreProps = {
  children: React.ReactNode;
};

const QueryParamsStoreInitializer: React.FC<SystemParamsStoreProps> = ({ children }) => {
  const { queryParamsStore } = rootStore;
  const [searchParams] = useSearchParams();

  queryParamsStore.update(searchParams);

  return <>{children}</>;
};

export default QueryParamsStoreInitializer;
